/* eslint-disable max-len */
import { createFeature, createReducer, createSelector, on } from '@ngrx/store';

import { OrdQueryActions } from './ord-query.actions';
import { OrdQueryI } from './models/ord-query.interface';
import { SharedStorageKeyEnum } from 'src/app/shared/_config/storage/shared-storage-key-enum';
import { SpxStorage } from '@softpak/components/spx-storage';

export interface State {
    data: OrdQueryI;
    hideSailings: boolean;
    sailing: string;
    showSearch: boolean;
    tableView: boolean;
}

export const initialState: State = {
    data: {
        query: null,
    },
    hideSailings: null,
    sailing: null,
    showSearch: false,
    tableView: SpxStorage.getSetting(SharedStorageKeyEnum.ordTableView) ? true : false,
};

export default createFeature({
    name: 'ordQuery',
    extraSelectors: ({ selectOrdQueryState }) => ({
        selectQuery: createSelector(
            selectOrdQueryState,
            (state) => state?.data?.query,
        ),
    }),
    reducer: createReducer(
        initialState,
        on(OrdQueryActions.reset, (state: State): State => ({
            ...state,
            data: {
                query: null,
            },
            showSearch: false,
        })),
        on(OrdQueryActions.set, (state: State, { query }): State => ({
            ...state,
            data: {
                query: query.query,
            }
        })),
        on(OrdQueryActions.switchView, (state: State): State => {
            if (!state.tableView) {
                SpxStorage.setSetting(SharedStorageKeyEnum.ordTableView, "YES");
            } else {
                SpxStorage.clearSetting(SharedStorageKeyEnum.ordTableView);
            }
            return {
                ...state,
                tableView: !state.tableView,
            };
        }),
        on(OrdQueryActions.sailing, (state: State, { hideSailings, sailing }): State => ({
            ...state,
            hideSailings,
            sailing,
        })),
        on(OrdQueryActions.hideSearch, (state: State, { }): State => ({
            ...state,
            showSearch: false,
        })),
        on(OrdQueryActions.toggleSearch, (state: State, { }): State => ({
            ...state,
            showSearch: !state.showSearch,
        }))
    )
}
);